export default __webpack_public_path__ + "static/tree_bottom-d10547d705a8f4380bf7c808b3a24772.png";